import React, { useEffect, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import TimeSpentConfirmationModal from "./TimeSpentConfirmationModal";
import { AiOutlineInfoCircle, AiOutlineWarning } from "react-icons/ai";

const ConfirmationModal = ({
  show,
  sendTo,
  messageType,
  jobServiceRowId,
  jobNo,
  jobTitle,
  resetState,
  title,
  children,
  danger,
}) => {
  const [showTimeSpentModal, setShowTimeSpentModal] = useState(false);
  const [showAlert, setShowAlert] = useState(show);

  useEffect(() => {
    setShowAlert(show);
  }, [show]);

  const customIcon = (
    <div>
      {danger ? (
        <AiOutlineWarning
          style={{
            fontSize: "80px",
            color: "#dc3545",
            margin: "20px auto",
          }}
        />
      ) : (
        <AiOutlineInfoCircle
          style={{
            fontSize: "80px",
            color: "rgb(70, 184, 218)",
            margin: "20px auto",
          }}
        />
      )}
    </div>
  );

  const dangerTitle = (
    <span style={{ fontSize: "18px", fontWeight: "normal" }}>
      Are you sure this Job is Ready to Send? This will generate an invoice and authorise the Job to be sent the Client
    </span>
  );

  const alertTitle = danger ? dangerTitle : (title || (
    <span style={{ fontSize: "18px", fontWeight: "normal" }}>
      Are you sure you have finalized your work on <b>{`${jobNo} - ${jobTitle}`}</b> and wish to send to{" "}
      <b>{messageType}</b>?
    </span>
  ));

  const handleMainConfirm = () => {
    setShowAlert(false);
    setShowTimeSpentModal(true)
  };

  const handleCancel = () => {
    setShowTimeSpentModal(false);
    resetState();
  };

  const handleTimeSpentConfirm = () => {
    setShowTimeSpentModal(false);
    sendTo();
    resetState();
  };

  const useCustomMode = danger || !title;

  return (
    <>
      {showAlert && (
        <SweetAlert
          custom={useCustomMode ? true : undefined}
          showCancel
          showCloseButton
          show={showAlert}
          type={useCustomMode ? undefined : "info"}
          title={alertTitle}
          style={{ width: "600px" }}
          closeOnClickOutside
          allowEscape={false}
          cancelBtnBsStyle="light"
          confirmBtnText="Send"
          confirmBtnCssClass={danger ? "btn btn-danger" : undefined}
          confirmBtnStyle={danger ? { border: "none", boxShadow: "none" } : undefined}
          customIcon={useCustomMode ? customIcon : undefined}
          onCancel={resetState}
          onConfirm={handleMainConfirm}
        >
          {children}
        </SweetAlert>
      )}

      <TimeSpentConfirmationModal
        jobServiceRowId={jobServiceRowId}
        show={showTimeSpentModal}
        resetState={handleCancel}
        sendTo={handleTimeSpentConfirm}
      />
    </>
  );
};

export default ConfirmationModal;
